import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-costcenter',
  templateUrl: './create-costcenter.component.html',
  styleUrls: ['./create-costcenter.component.css']
})
export class CreateCostCenterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
